export default function PageHeader({ overline, title, subtitle, children, testid }) {
  return (
    <div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between" data-testid={testid}>
      <div>
        {overline && <p className="overline mb-1.5">{overline}</p>}
        <h1 className="font-heading text-2xl font-bold sm:text-3xl">{title}</h1>
        {subtitle && <p className="mt-1 text-sm text-muted-foreground">{subtitle}</p>}
      </div>
      {children && <div className="flex flex-wrap items-center gap-2">{children}</div>}
    </div>
  );
}
